// extracted by mini-css-extract-plugin
export default {"buttonContainer":"kit-table_buttonContainer__0YaAG","kitsPage":"kit-table_kitsPage__vYDI-"};